import { render, staticRenderFns } from "./DeleteTemplateImages.vue?vue&type=template&id=3184f903&scoped=true"
import script from "./DeleteTemplateImages.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateImages.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateImages.vue?vue&type=style&index=0&id=3184f903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184f903",
  null
  
)

export default component.exports